import { createApi } from "@reduxjs/toolkit/query/react";
import { VITE_API_V2_URL } from "codes";
import { axiosBaseQuery } from "helpers/axiosbaseQuery";

export interface LeadComment {
  id: string;
  lead_id: string;
  comment: string;
  user_id: string;
  user_name: string;
  is_internal: boolean;
  created_at: string;
}

export interface CreateLeadCommentRequest {
  lead_id: string;
  comment: string;
}

export const leadComments = createApi({
  reducerPath: "leadComments",
  tagTypes: ["LEAD_COMMENTS"],
  baseQuery: axiosBaseQuery({
    baseUrl: `${VITE_API_V2_URL}`,
  }),
  endpoints: (builder) => ({
    getLeadComments: builder.query<LeadComment[], string>({
      query: (leadId) => ({
        url: `/lead-comments/${leadId}`,
        method: "get",
      }),
      transformResponse: (response: any) => response.data,
      providesTags: (result, error, leadId) => [
        { type: "LEAD_COMMENTS", id: leadId },
        "LEAD_COMMENTS",
      ],
    }),
    
    createLeadComment: builder.mutation<LeadComment, CreateLeadCommentRequest>({
      query: (body) => ({
        url: "/lead-comments",
        method: "post",
        data: body,
      }),
      transformResponse: (response: any) => response.data,
      invalidatesTags: (result, error, { lead_id }) => [
        { type: "LEAD_COMMENTS", id: lead_id },
        "LEAD_COMMENTS",
      ],
    }),
  }),
});

export const {
  useGetLeadCommentsQuery,
  useCreateLeadCommentMutation,
} = leadComments;
